import { LanguageType } from 'types';

export const CODELIST_SIDEBAR_DICTIONARY = {
	[LanguageType.English]: {
		ssn: {
			label: 'Social Security Number'
		},
		firstName: {
			label: 'First name'
		},
		lastName: {
			label: 'Last name'
		},
		dateOfBirth: {
			label: 'Date of birth'
		},
		mobilePhone: {
			label: 'Mobile phone'
		},
		email: {
			label: 'Email'
		},
		address: {
			label: 'Address'
		},
		postalCode: {
			label: 'Postal code'
		},
		postalPlace: {
			label: 'Postal place'
		},
		country: {
			label: 'Country'
		},
		customId: {
			label: 'Custom ID'
		}
	},

	[LanguageType.Norwegian]: {
		ssn: {
			label: 'Personnummer'
		},
		firstName: {
			label: 'Fornavn'
		},
		lastName: {
			label: 'Etternavn'
		},
		dateOfBirth: {
			label: 'Fødselsdato'
		},
		mobilePhone: {
			label: 'Mobiltelefon'
		},
		email: {
			label: 'E-post'
		},
		address: {
			label: 'Adresse'
		},
		postalCode: {
			label: 'Postnummer'
		},
		postalPlace: {
			label: 'Poststed'
		},
		country: {
			label: 'Land'
		},
		customId: {
			label: 'Egendefinert ID'
		}
	}
};
